import React, { useEffect, useState } from 'react'
import styles from '../sass/megamenu.module.scss'
import { fetchAllCategories } from '../redux/actions/CategoryActions'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';

const MegaMenu = ({onClose, showAppInstall }) => {
  const dispatch = useDispatch();
  const { categories, loader } = useSelector((state) => state.categories);
  const { token } = useSelector((state) => state.user);
  const [activeCategory, setActiveCategory] = useState(null);

  useEffect(() => {
    dispatch(fetchAllCategories());
  }, [dispatch]);

  // Set first category as active when categories are loaded
  useEffect(() => {
    if (categories.length > 0 && activeCategory === null) {
      setActiveCategory(categories[0].id);
    }
  }, [categories]);

  if (loader) {
    return <div className={styles.loadingText}>Loading...</div>;
  }

  return (
    <div className={`${styles.megaMenu} ${!showAppInstall ? styles.megaMenuTop : ''}`}>
      {/* Desktop menu - hidden on mobile */}
      <div className={styles.desktopMenu}>
        <div className={styles.megaMenu_leftSide}>
          <div className={styles.directionColumn}>
              {categories.map((category) => (
                  <div
                      key={category.id}
                      className={`${styles.parentCategory} ${activeCategory === category.id ? styles.active : ''}`}
                      onClick={() => setActiveCategory(category.id)}
                  >{category.name}</div>
              ))}
          </div>
        </div>
        <div className={styles.megaMenu_rightSide}>
          <div className={styles.directionRow}>
          {categories
              .filter((category) => category.id === activeCategory)
              .map((category) =>
                category.children?.length ? (
                  <div key={category.id} className={styles.childCategoryList}>
                    <div className={styles.childItem_wrapper}>
                      {category.children.map((sub) => (
                          <div className={styles.childItem_directionColumn}>
                              <Link   onClick={onClose} key={sub.id} to={`/category/${sub.slug}`} className={styles.childItem_title}>{sub.name}</Link>
                              {sub.children.map((esub) => (
                              <div className={styles.childItem_sub_directionColumn}>
                                  <Link   onClick={onClose} key={esub.id} to={`/category/${esub.slug}`} className={styles.childItem_subtitle}>{esub.name}</Link>
                              </div>
                               ))}

                          </div>
                      ))}
                    </div>
                  </div>
                ) : (
                  <p key={category.id} className={styles.noChildText}>
                    Explore other categories
                  </p>
                )
              )}
          </div>
        </div>
      </div>

      {/* Mobile-only menu links */}
      <div className={styles.mobileMenuLinks}>
        <div className={styles.mobileMenuLink}>
          <Link onClick={onClose} to={token ? "/profile" : "/login"}>
            {token ? "Profile" : "Login"}
          </Link>
        </div>
        <div className={styles.mobileMenuLink}>
          <Link onClick={onClose} to="/orders">Orders</Link>
        </div>
        <div className={styles.mobileMenuLink}>
          <Link onClick={onClose} to="/brands">Brands</Link>
        </div>
        <div className={styles.mobileMenuLink}>
          <Link onClick={onClose} to="/about-us">About</Link>
        </div>
        <div className={styles.mobileMenuLink}>
          <Link onClick={onClose} to="/contact-us">Contact</Link>
        </div>
        <div className={styles.mobileMenuLink}>
          <Link onClick={onClose} to="/careers">Careers</Link>
        </div>
      </div>

      {/* <div className={styles.menuItem}>
        <a href="#">Shop by Category</a>
          <div className={styles.megaDropdown}>
          {categories.map((category) => (
              <div className={styles.dropdownContent} key={category.id}>
                <h3>{category.name}</h3>
                <ul>
                  {category.children.map((sub) => (
                    <li key={sub.id}>
                      <a href={`/category/${sub.id}`}>{sub.name}</a>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
      </div> */}
    </div>
  );
};

export default MegaMenu;
